import MUIDataTable from "mui-datatables";
import React, { useState, useEffect, FunctionComponent } from "react";
//import { makeStyles, createStyles, Theme, MuiThemeProvider } from "@material-ui/core/styles";
import { api } from "../../api";
import moment from "moment";
import Table from "@material-ui/core/Table";
import { useTableStyles } from "../useTableStyle";
import { TableCell, TableRow, Typography } from "@material-ui/core";
import { useItemReturnStyles } from "./useItemReturnStyles";
import { ThemeProvider } from "@mui/material/styles";
import CircularProgress from '@mui/material/CircularProgress';
const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};
const columns = [
  "Purchased Bill No",
  " Returned Bill No",
  "Amount",
  "Terminal",
  "With Bill",
  "Created Date",
  "Status",
  "",
];

interface ItemData {
  purchased_bill_doc_no: string | null;
  ret_bill_doc_no: string | null;
  total_amount: number | null;
  pos_no: string | null;
  with_bill: string;
  created_at: string | null;
  status: string | null;
  barcode_no: string;
}

interface returnDataProps {
  getVoucherDetails: (voucherCode: number) => void;
}

export const ItemReturnDetailsTable: FunctionComponent<returnDataProps> = ({
  getVoucherDetails
}) => {

  const classes = useItemReturnStyles();
  const getMuiTheme = useTableStyles();
  const [itemData, setItemData] = useState<ItemData[]>([]);
  const [loading, setLoading] = useState(true);
  const options = {
    selectableRows: undefined,
    selectableRowsHeader: false,
    rowsPerPage: 500,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100,500],
    search: true,
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    display: true,
    responsive: undefined,
    fixedHeaderOptions: {
      xAxis: false,
      yAxis: true,
    },

    isRowSelectable: function () {
      return false;
    },

    customRowRender: (data: any) => {
      return (
        <TableRow className={classes.tableRow}
          onClick={() => getVoucherDetails(data[7])}
        >
          <TableCell>
            <Typography className={classes.tableCell}>{data[0]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[1]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[2]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[3]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[4]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[5]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[6]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{""}</Typography>
          </TableCell>
        </TableRow>
      );
    }
  };

  useEffect(() => {
    const FetchItemData = async () => {
      try {
        setLoading(true);
        const itemsList = await api.get(`item-return/itemReturnDetails`);
        if(itemsList){
        setItemData(itemsList);
        setLoading(false);
        }
        else
        {
          setLoading(false);
        }
      } catch (error) {
        console.log("error - ", error);
      }
    };
    FetchItemData();
  }, []);

  /* useEffect(() => {
    if (itemData && itemData.length > 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [itemData]); */

  /* if (itemData && itemData.length > 0) {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider  theme={getMuiTheme}>
            <MUIDataTable
              title={"Item Return List"}
              data={itemData.map((row: any) => {
                return [
                  row.purchased_bill_doc_no === null
                    ? "Nil"
                    : row.purchased_bill_doc_no,
                  row.ret_bill_doc_no === null ? "Nil" : row.ret_bill_doc_no,
                  row.total_amount === null || row.total_amount === undefined ? "Nil" : `${row.total_amount} QR`,
                  row.pos_no === null ? "Nil" : row.pos_no,
                  row.with_bill === "true" ? "Yes" : "No",
                  row.created_at === null
                    ? "-"
                    : moment(row.created_at).format("DD-MMM-YYYY  h:mm:ss a"),
                  row.status === null ? "-" : row.status,
                  row.barcode_no
                ];
              })}
              columns={columns}
              options={options}
            />
          </ThemeProvider >
        </Table>
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider  theme={getMuiTheme}>
            <MUIDataTable
              title={"Item Return List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider >
        </Table>
      </div>
    );
  } */


  return (
    <div className={classes.root}>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
        </div>
      ) : (
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Item Return List"}
              data={itemData.map((row) => {
                return [
                  row.purchased_bill_doc_no === null ? "Nil" : row.purchased_bill_doc_no,
                  row.ret_bill_doc_no === null ? "Nil" : row.ret_bill_doc_no,
                  row.total_amount === null || row.total_amount === undefined ? "Nil" : `${row.total_amount} QR`,
                  row.pos_no === null ? "Nil" : row.pos_no,
                  row.with_bill === "true" ? "Yes" : "No",
                  row.created_at === null ? "-" : moment(row.created_at).format("DD-MMM-YYYY  h:mm:ss a"),
                  row.status === null ? "-" : row.status,
                  row.barcode_no
                ];
              })}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
      )}
    </div>
  );
};

